var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import { ApplicationContext } from '../../../ApplicationContext';
import ServiceEntriesControls from './ServiceEntriesControls';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
import ClosedServiceEntriesRow from './ClosedServiceEntriesRow';
import ServiceEntryCollection from '../../../collections/services/ServiceEntryCollection';
import GetClosedServiceEntriesCommand from '../../../commands/services/GetClosedServiceEntriesCommand';
import TableModel from "../../../models/TableModel";
import Signals from "../../../signals/Signals";
import TableSettingsOverlay from "../../components/ui/TableSettingsOverlay/TableSettingsOverlay";
import GetAllClosedServiceEntriesCommand from '../../../commands/services/GetAllClosedServiceEntriesCommand';
import Page from "../Page";
/**
 *
 */
var ClosedServiceEntries = /** @class */ (function (_super) {
    __extends(ClosedServiceEntries, _super);
    /**
     *
     * @param props
     */
    function ClosedServiceEntries(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            closedServiceEntryCollection: new ServiceEntryCollection(true, 'ClosedServiceEntryCollection'),
            tableModel: new TableModel(),
            currentPage: 1,
            totalPages: 0,
            maxNumberOfItemsPerPage: 100
        };
        _this.state.closedServiceEntryCollection.sort.fieldName = 'closeDateTimeUtc';
        _this.setTableRef = _this.setTableRef.bind(_this);
        _this.onTableScroll = _this.onTableScroll.bind(_this);
        _this.onPageSelect = _this.onPageSelect.bind(_this);
        return _this;
    }
    /**
     *
     */
    ClosedServiceEntries.prototype.componentDidMount = function () {
        var _this = this;
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, closedServiceEntryCollection = _a.closedServiceEntryCollection, currentPage = _a.currentPage, maxNumberOfItemsPerPage = _a.maxNumberOfItemsPerPage;
        var command = new GetClosedServiceEntriesCommand();
        command.execute(session.user.organisation, closedServiceEntryCollection, currentPage, maxNumberOfItemsPerPage).then(function (response) {
            _this.setState({
                totalPages: Math.ceil(response.totalResults / response.numberOfItemsPerPage),
                currentPage: response.currentPage
            });
        });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ClosedServiceEntries.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var table = this.state.table;
        if (table) {
            if (table.scrollTop > table.offsetHeight) {
                table.scrollIntoView();
            }
        }
    };
    /**
     *
     */
    ClosedServiceEntries.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var intl = this.props.intl;
        var _a = this.state, closedServiceEntryCollection = _a.closedServiceEntryCollection, tableModel = _a.tableModel, totalPages = _a.totalPages, currentPage = _a.currentPage;
        if (!intl)
            return null;
        return React.createElement(Page, { pageName: "service-entries" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement("div", { className: "card mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement("div", { className: "card-header flex-grow-0" },
                        React.createElement("h1", null,
                            React.createElement(FormattedMessage, { id: 'page.closed.service.entries.title' })),
                        React.createElement(ServiceEntriesControls, { hideFilters: true, hideSearchControls: true, hideCreateManual: true, serviceEntryCollection: closedServiceEntryCollection },
                            React.createElement("div", { className: "d-flex justify-content-end align-items-start button-grid" },
                                React.createElement("div", { className: "nav btn-group dropdown", role: "group" },
                                    React.createElement("button", { className: "btn btn-white dropdown-toggle", type: "button", id: "exportFileButton", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                                        React.createElement("div", { className: "d-none d-md-inline" },
                                            React.createElement(FormattedMessage, { id: "label.exportAllClosed", defaultMessage: "Export" })),
                                        React.createElement("span", { className: "d-md-none fe fe-download" })),
                                    React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "exportFileButton" },
                                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function () {
                                                _this.exportAllClosedServiceEntries('xlsx');
                                            } },
                                            React.createElement("span", null, "xlsx")),
                                        React.createElement("a", { className: "dropdown-item", href: "#", onClick: function () {
                                                _this.exportAllClosedServiceEntries('csv');
                                            } },
                                            React.createElement("span", null, "csv")))),
                                tableModel ?
                                    React.createElement("div", { className: "nav btn-group d-inline-flex dropdown ml-3", role: "group" },
                                        React.createElement("button", { className: "btn btn-white", type: "button", id: "tableSettings", onClick: function () {
                                                Signals.ShowOverlay.dispatch(React.createElement(TableSettingsOverlay, { tableModel: tableModel }));
                                            } },
                                            React.createElement("span", { className: "fe fe-settings" }))) : null))),
                    React.createElement("div", { className: "card-body pt-0 mr-4 pr-0 overflow-auto" },
                        React.createElement("div", { className: "table-container h-100 w-100 flex-fill" },
                            React.createElement("div", { className: "" },
                                React.createElement("div", { className: "w-100", style: {
                                        display: "grid",
                                        gridTemplateColumns: "1fr 3fr 1fr 3fr 1fr 1fr 1fr 1fr 1fr",
                                        rowGap: "1.3rem",
                                        minWidth: "fit-content"
                                    } },
                                    React.createElement("div", { className: 'w-100 position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0 } },
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.closed" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.name" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.assetid" })),
                                        React.createElement("div", { className: "w-100" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.description" })),
                                        React.createElement("div", { className: "w-100" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.resolution" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.assignedto" })),
                                        React.createElement("div", null,
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.operator" })),
                                        React.createElement("div", { className: "self-align-end" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.valueoncreate" })),
                                        React.createElement("div", { className: "self-align-end" },
                                            React.createElement(FormattedMessage, { id: "page.service.entries.table.column.valueonclose" }))),
                                    closedServiceEntryCollection.filtered.length > 0 ?
                                        closedServiceEntryCollection.filteredAndSorted.map(function (serviceEntryModel, index) {
                                            return React.createElement(ClosedServiceEntriesRow, { key: index + '-' + serviceEntryModel.assetEquipmentId, serviceEntryModel: serviceEntryModel, compact: tableModel.compact });
                                        }) : React.createElement(EmptyDivRow, null))))))));
    };
    ClosedServiceEntries.prototype.onPageSelect = function (page) {
        var _this = this;
        this.setState({ currentPage: page }, function () { return _this.componentDidMount(); });
    };
    /**
     *
     */
    ClosedServiceEntries.prototype.onTableScroll = function () {
        var _a = this.state, thead = _a.thead, tableContainer = _a.tableContainer;
        thead.style.transform = 'translateY(' + tableContainer.scrollTop + 'px)';
        if (tableContainer.scrollTop < 5 && thead.classList.contains('box-shadow')) {
            thead.classList.remove('box-shadow');
        }
        if (tableContainer.scrollTop > 5 && !thead.classList.contains('box-shadow')) {
            thead.classList.add('box-shadow');
        }
    };
    /**
     * @param exportType
     */
    ClosedServiceEntries.prototype.exportAllClosedServiceEntries = function (exportType) {
        var session = this.context.session;
        var intl = this.props.intl;
        var command = new GetAllClosedServiceEntriesCommand();
        command.execute(session.user.organisation).then(function (response) {
            var resultServiceCollection = new ServiceEntryCollection();
            resultServiceCollection.addAll(response);
            resultServiceCollection.exportClosed(exportType, intl);
        });
    };
    /**
     *
     * @param ref
     */
    ClosedServiceEntries.prototype.setTableRef = function (ref) {
        if (ref) {
            var table = ref.querySelector('table');
            var thead = ref.querySelector('thead');
            this.setState({ table: table, thead: thead, tableContainer: ref });
            ref.addEventListener('scroll', this.onTableScroll);
        }
    };
    ClosedServiceEntries.defaultProps = {
        className: ''
    };
    ClosedServiceEntries = __decorate([
        observer
    ], ClosedServiceEntries);
    return ClosedServiceEntries;
}(React.Component));
ClosedServiceEntries.contextType = ApplicationContext;
export default injectIntl(ClosedServiceEntries);
